<template>
  <div id="targetControl">
    <b-collapse :visible="this.targetListVisibility" id="targetList">
      <div class="targetActionButtonsDiv">
        <b-button class="btn btn-primary btn-sm" @click="addTargets('display')" v-b-tooltip.hover :title="$t('announcement_targets.add_displ_target_btn')"><b-icon icon="display" font-scale="1.5"></b-icon></b-button>
        <b-button class="btn btn-primary btn-sm" @click="addTargets('line')" v-b-tooltip.hover :title="$t('announcement_targets.add_line_target_btn')"><b-icon icon="arrow-left-right" font-scale="1.5"></b-icon></b-button>
        <b-button class="btn btn-primary btn-sm" @click="addTargets('route')" v-b-tooltip.hover :title="$t('announcement_targets.add_route_target_btn')"><b-icon icon="arrow-left" font-scale="1.5"></b-icon></b-button>
        <b-button class="btn btn-primary btn-sm" @click="addTargets('stop')" v-b-tooltip.hover :title="$t('announcement_targets.add_stop_target_btn')"><b-icon icon="flag-fill" font-scale="1.5"></b-icon></b-button>
        <b-button class="btn btn-primary btn-sm" @click="addTargets('displaygroup')" v-b-tooltip.hover :title="$t('announcement_targets.add_displaygroup_target_btn')"><b-icon icon="files" font-scale="1.5"></b-icon></b-button>
        <b-button class="btn btn-danger btn-sm" v-b-tooltip.hover v-on:click="removeTargets" :title="$t('announcement_targets.del_target_btn')"><b-icon icon="X" font-scale="1.5"></b-icon></b-button>
      </div>
      <AnnouncementTargetList ref="targetList" v-bind:targetdata="this.targetList"></AnnouncementTargetList>
    </b-collapse>
    <!-- Näytöt -->
    <b-collapse :visible="this.displayListVisibility">
      <b-button class="btn btn-primary btn-sm" v-b-tooltip.hover :title="$t('announcement_targets.ok_btn')" v-on:click="submitAddDisplayTargets"><b-icon icon="flag-fill" font-scale="1.5"></b-icon>{{$t('announcement_targets.ok_btn')}}</b-button>
      <b-button class="btn btn-danger btn-sm" v-b-tooltip.hover :title="$t('announcement_targets.cancel_btn')" @click="addTargets('targetlist')"><b-icon icon="X" font-scale="1.5"></b-icon> {{$t('announcement_targets.cancel_btn')}}</b-button>
      <b-button class="btn btn-primary btn-sm" v-b-tooltip.hover :title="$t('announcement_targets.add_all_btn')" v-on:click="submitAddAllDisplayTargets"><b-icon icon="flag-fill" font-scale="1.5"></b-icon>{{$t('announcement_targets.add_all_btn')}}</b-button>
      <SmallDisplayList ref="smallDispList" :dontShow="notValidTargets" :perPage="10"></SmallDisplayList>
    </b-collapse>

    <!-- Linjat -->
    <b-collapse :visible="this.lineListVisibility">
      <b-button class="btn btn-primary btn-sm" v-b-tooltip.hover :title="$t('announcement_targets.ok_btn')" v-on:click="submitAddLineTargets"><b-icon icon="flag-fill" font-scale="1.5"></b-icon>{{$t('announcement_targets.ok_btn')}}</b-button>
      <b-button class="btn btn-danger btn-sm" v-b-tooltip.hover :title="$t('announcement_targets.cancel_btn')" @click="addTargets('targetlist')"><b-icon icon="X" font-scale="1.5"></b-icon> {{$t('announcement_targets.cancel_btn')}}</b-button>
      <LineList ref="lineList"></LineList>
    </b-collapse>

    <!-- Reitit -->
    <b-collapse :visible="this.routeListVisibility">
      <b-button class="btn btn-primary btn-sm" v-b-tooltip.hover :title="$t('announcement_targets.ok_btn')" v-on:click="submitAddRouteTargets"><b-icon icon="flag-fill" font-scale="1.5"></b-icon>{{$t('announcement_targets.ok_btn')}}</b-button>
      <b-button class="btn btn-danger btn-sm" v-b-tooltip.hover :title="$t('announcement_targets.cancel_btn')" @click="addTargets('targetlist')"><b-icon icon="X" font-scale="1.5"></b-icon> {{$t('announcement_targets.cancel_btn')}}</b-button>
      <RouteList ref="routeList"></RouteList>
    </b-collapse>

    <!-- Pysäkit -->
    <b-collapse :visible="this.pysakkiListVisibility">
      <b-button class="btn btn-primary btn-sm" v-b-tooltip.hover :title="$t('announcement_targets.ok_btn')" v-on:click="submitAddPysakkiTargets"><b-icon icon="flag-fill" font-scale="1.5"></b-icon>{{$t('announcement_targets.ok_btn')}}</b-button>
      <b-button class="btn btn-danger btn-sm" v-b-tooltip.hover :title="$t('announcement_targets.cancel_btn')" @click="addTargets('targetlist')"><b-icon icon="X" font-scale="1.5"></b-icon> {{$t('announcement_targets.cancel_btn')}}</b-button>
      <PysakkiList ref="pysakkiList"></PysakkiList>
    </b-collapse>

    <!-- Näyttöryhmät -->
    <b-collapse v-if="$UIPrivilegeUpdate('devices', 'ssedisplay_groups')" :visible="this.displayGroupListVisibility">
      <b-button class="btn btn-primary btn-sm" v-b-tooltip.hover :title="$t('announcement_targets.ok_btn')" v-on:click="submitAddDisplayGroupTargets"><b-icon icon="flag-fill" font-scale="1.5"></b-icon>{{$t('announcement_targets.ok_btn')}}</b-button>
      <b-button class="btn btn-danger btn-sm" v-b-tooltip.hover :title="$t('announcement_targets.cancel_btn')" @click="addTargets('targetlist')"><b-icon icon="X" font-scale="1.5"></b-icon> {{$t('announcement_targets.cancel_btn')}}</b-button>
      <SmallDisplayGroupList ref="smallDispGroupList" :dontShow="notValidTargets" :perPage="10"></SmallDisplayGroupList>
    </b-collapse>
  </div>
</template>

<script>
import AnnouncementTargetList from '@/components/Announcements/AnnouncementTargetList.vue';
import SmallDisplayList from '@/components/Display/SmallDisplayList.vue';
import SmallDisplayGroupList from '@/components/Display/SmallDisplayGroupList.vue';
import RouteList from '@/components/Timetable/RouteList.vue'
import LineList from '@/components/Timetable/LineList.vue'
import PysakkiList from '@/components/Timetable/PysakkiList.vue'

export default {
  name: 'AnnouncementTargetControl',
  props: {
    targetdata: Array,
    creatingNew: Boolean,
    notValidTargets: Array
  },
  data: function() {
        return {
          displayListVisibility: false,
          displayGroupListVisibility: false,
          lineListVisibility: false,
          routeListVisibility: false,
          pysakkiListVisibility: false,
          targetListVisibility: true,
          targetList: [],
          creatingNewTargets: false
        };
  },
  components: {
    AnnouncementTargetList,
    SmallDisplayList,
    PysakkiList,
    LineList,
    RouteList,
    SmallDisplayGroupList
  },
  created: function() {
    this.targetList = this.targetdata;
  },
  mounted: function() {

  },
  watch: {
    targetdata: function() {
      this.targetList = this.targetdata;
    },
    selectedAnnouncements: function() {
      if (this.selectedAnnouncements.length != 1) {
        this.clearTargetLists();
      }
    },
    creatingNew: function() {
      if(this.creatingNew) {
        this.createNewAnnouncement();
      }
    }
  },
  methods: {
    onRowSelected(items) {
      this.selected = items;
    },
    clearTargetLists() {
      this.$refs.targetList.emptyList();
    },
    addTargets(target) {
      this.displayListVisibility = false;
      this.lineListVisibility = false;
      this.routeListVisibility = false;
      this.pysakkiListVisibility = false;
      this.displayGroupListVisibility = false;
      this.targetListVisibility = false;

      switch (target) {
        case 'display':
          this.displayListVisibility = true;
          break;
        case 'line':
          this.lineListVisibility = true;
          break;
        case 'route':
          this.routeListVisibility = true;
          break;
        case 'stop':
          this.pysakkiListVisibility = true;
          break;
        case 'displaygroup':
          this.displayGroupListVisibility = true;
          break;
        case 'targetlist':
          this.targetListVisibility = true;
          break;
        default:
          this.targetListVisibility = true;
      }
    },
    hideTargetLists() {
      this.lineListVisibility = false;
      this.routeListVisibility = false;
      this.pysakkiListVisibility = false;
      this.displayListVisibility = false;
      this.targetListVisibility = true;
      this.displayGroupListVisibility = false;
    },
    createNewAnnouncement() {
      this.targetListVisibility = true;
      this.displayListVisibility = false;
      this.$refs.targetList.emptyList();
    },
    submitAddAllDisplayTargets() {
      var toBeAdded = this.$refs.smallDispList.getDisplayList();
      //console.log("toBeAdded length: " + toBeAdded.length);
      var targetList = [];
      toBeAdded.forEach((item) => {
          var entry={"id":null,"label":null,type:"display"};
          entry.id = item.id;
          entry.label = item.label;
          if(entry.label == null || entry.label.length == 0) {
            entry.label = item.name;
          }
          targetList.push(entry);
      });
      this.$refs.targetList.addTargets(targetList);
      this.$refs.smallDispList.deselectAll();
      this.hideTargetLists();
    },
    submitAddDisplayTargets() {
      var toBeAdded = this.$refs.smallDispList.getSelectedList();
      //console.log(toBeAdded);
      var targetList = [];
      toBeAdded.forEach((item) => {
          var entry={"id":null,"label":null,type:"display"};
          entry.id = item.id;
          entry.label = item.label;
          if(entry.label == null || entry.label.length == 0) {
            entry.label = item.name;
          }
          targetList.push(entry);
      });
      this.$refs.targetList.addTargets(targetList);
      this.$refs.smallDispList.deselectAll();
      this.hideTargetLists();
    },
    submitAddDisplayGroupTargets() {
      var toBeAdded = this.$refs.smallDispGroupList.getSelectedList();
     // console.log(toBeAdded);
      var targetList = [];
      toBeAdded.forEach((item) => {
        item.devices.forEach((device) => {
          var entry = { "id": null, "label": null, type: "displayGroup" };
          entry.id = device.uniqueId; 
          entry.label = device.name;
          console.log("entry:", entry)
          targetList.push(entry);
        });
      });
      this.$refs.targetList.addTargets(targetList);
      this.$refs.smallDispGroupList.deselectAll();
      this.hideTargetLists();
    },

    submitAddLineTargets() {
      var toBeAdded = this.$refs.lineList.getSelectedList();
      //console.log(toBeAdded);
      var targetList = [];
      toBeAdded.forEach((item) => {
          var entry={"id":null,"label":null,type:"line"};
          entry.id = item.tunnus;
          entry.label = item.nimi;
          targetList.push(entry);
      });
      this.$refs.targetList.addTargets(targetList);
      this.$refs.lineList.deselectAll();
      this.hideTargetLists();
    },
    submitAddRouteTargets() {
      var toBeAdded = this.$refs.routeList.getSelectedList();
      //console.log(toBeAdded);
      var targetList = [];
      toBeAdded.forEach((item) => {
          var entry={"id":null,"label":null,type:"route"};
          entry.id = item.tunnus;
          entry.label = item.nimi;
          targetList.push(entry);
      });
      this.$refs.targetList.addTargets(targetList);
      this.$refs.routeList.deselectAll();
      this.hideTargetLists();
    },
    submitAddPysakkiTargets() {
      var toBeAdded = this.$refs.pysakkiList.getSelectedList();
      //console.log(toBeAdded);
      var targetList = [];
      toBeAdded.forEach((item) => {
          var entry={"id":null,"label":null,type:"pysakki"};
          entry.id = item.tunnus;
          entry.label = item.nimi;
          targetList.push(entry);
      });
      this.$refs.targetList.addTargets(targetList);
      this.$refs.pysakkiList.deselectAll();
      this.hideTargetLists();
    },
    removeTargets() {
      this.$refs.targetList.removeSelectedTargets();
    },
    getTargets() {
      return this.$refs.targetList.getTargetListData();
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.targetActionButtonsDiv {
}
</style>
